import React, { useContext, useEffect, useRef } from "react";
import { UNSAFE_DataRouterContext, useBlocker } from "react-router-dom";

export function AccountLeaveDialog({ busy, onStay, onLeave }) {
  const dialog = useRef(null);
  // Capture before React's autoFocus moves focus into the newly mounted dialog.
  const previousFocus = useRef(document.activeElement);
  useEffect(() => {
    const focused = previousFocus.current;
    const element = dialog.current;
    if (element?.showModal) element.showModal();
    else element?.setAttribute("open", "");
    return () => { element?.close?.(); if (focused?.isConnected) focused.focus?.(); };
  }, []);
  return <dialog ref={dialog} className="account-leave-dialog" aria-labelledby="account-leave-title" aria-describedby="account-leave-description" onCancel={event => { event.preventDefault(); onStay(); }}>
    <h2 id="account-leave-title">{busy ? "A save is in progress" : "Leave with unsaved changes?"}</h2>
    <p id="account-leave-description">{busy ? "Wait for your save to finish before leaving this page." : "Changes in your account sections will be lost. Stay to save them, or leave without saving."}</p>
    <div className="account-section-actions"><button type="button" autoFocus className="account-primary" onClick={onStay}>Keep editing</button>{!busy && <button type="button" className="account-text-button" onClick={onLeave}>Leave without saving</button>}</div>
  </dialog>;
}

function RouterGuard({ dirty, busy, bypass }) {
  const blocker = useBlocker(({ currentLocation, nextLocation }) => !bypass.current && (dirty || busy)
    && (currentLocation.pathname !== nextLocation.pathname || currentLocation.search !== nextLocation.search));
  return blocker.state === "blocked" ? <AccountLeaveDialog busy={busy} onStay={() => blocker.reset()} onLeave={() => blocker.proceed()} /> : null;
}

export default function AccountNavigationGuard(props) {
  const router = useContext(UNSAFE_DataRouterContext);
  useEffect(() => {
    if (!props.dirty && !props.busy) return undefined;
    const prevent = event => { if (props.bypass.current) return; event.preventDefault(); event.returnValue = ""; };
    window.addEventListener("beforeunload", prevent);
    return () => window.removeEventListener("beforeunload", prevent);
  }, [props.dirty, props.busy, props.bypass]);
  return router ? <RouterGuard {...props} /> : null;
}
